import tiktokIconSvg from 'assets/images/tiktok.svg'
import facebookIconSvg from 'assets/images/facebook.svg'
import instagramIconSvg from 'assets/images/instagram.svg'
import twitterIconSvg from 'assets/images/twitter.svg'

// TODO Add links
export const socialIcons = [
  { src: tiktokIconSvg, alt: 'tiktok icon' },
  { src: twitterIconSvg, alt: 'twitter icon' },
  { src: instagramIconSvg, alt: 'instagram icon' },
  { src: facebookIconSvg, alt: 'facebook icon' },
]
